import { create } from 'zustand';
import type { BankAccount, SharedBankAccount } from '../types';
import api from '../services/api';

interface BankAccountState {
  bankAccounts: BankAccount[];
  sharedBankAccounts: SharedBankAccount[];
  isLoaded: boolean;
  isSharedLoaded: boolean;

  // Actions
  setBankAccounts: (accounts: BankAccount[]) => void;
  setSharedBankAccounts: (accounts: SharedBankAccount[]) => void;
  fetchBankAccounts: () => Promise<void>;
  fetchSharedBankAccounts: () => Promise<void>;
  reset: () => void;
}

export const useBankAccountStore = create<BankAccountState>()((set) => ({
  bankAccounts: [],
  sharedBankAccounts: [],
  isLoaded: false,
  isSharedLoaded: false,

  setBankAccounts: (accounts) => set({ bankAccounts: accounts, isLoaded: true }),

  setSharedBankAccounts: (accounts) => set({ sharedBankAccounts: accounts, isSharedLoaded: true }),

  fetchBankAccounts: async () => {
    try {
      const response = await api.get('/bank-accounts');
      if (response.data.success) {
        set({ bankAccounts: response.data.data, isLoaded: true });
      }
    } catch {
      // Ignorer les erreurs
    }
  },

  fetchSharedBankAccounts: async () => {
    try {
      const response = await api.get('/shared-bank-accounts');
      if (response.data.success) {
        set({ sharedBankAccounts: response.data.data, isSharedLoaded: true });
      }
    } catch {
      // Ignorer les erreurs
    }
  },

  reset: () => set({ bankAccounts: [], sharedBankAccounts: [], isLoaded: false, isSharedLoaded: false }),
}));
